module.exports = __webpack_public_path__ + "img/stop-icon.d1a81f04.png";